import React, { useEffect, useState } from 'react'
import { Tabs, Button } from 'antd';
import './contribution.css'
import { IoMdArrowBack } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';
import MyContribution from './MyContribution';
import TeamContribution from './TeamContribution';
import { Radio } from 'antd';
import { Select } from 'antd';
import MarketShare from './MarketShare';
import IncentiveAmount from './Incentive/Incentive';
import IncentiveDescription from './Incentive/IncentiveDescription';
import { InfoCircleOutlined } from '@ant-design/icons';


function Main({ accessLevel,accessList }) {
    const [tab, setTab] = useState(null)
    const [tablist, setTablist] = useState(['My Contribution'])
    const [teamName,setTeamName]=useState('All')
    const location = useLocation()
    const path = location.pathname
    const tabName = path.split('/')[path.split('/').length - 1]
    const navigate = useNavigate()
    let k = 1;

    const modalityOption = [
        { value: 'XRAY', label: 'XRAY' },
        { value: 'CT', label: 'CT' },
        { value: 'MRI', label: 'MRI' },
        { value: 'NM', label: 'NM' }]

    const [modality, setModality] = useState(['XRAY', 'CT', 'MRI', 'NM'])
    const [radioValue, setRadioValue] = useState((tabName === 'marketshare') ? 'state' : 'weekly');
    const onWeeklyChange = (e) => {
        setRadioValue(e.target.value);
    };

    const onChange = (key) => {
        // console.log(key);
        let temp;
        if (key === 'My Contribution') {
            temp = 'my'
            setRadioValue('weekly')
        } else if (key === 'Team Contribution') {
            temp = 'team'
            setRadioValue('weekly')
        }
        else if (key === 'Market Share') {
            temp = 'marketshare'
            setRadioValue('state')
        }
        else if (key === 'Incentive Amount') {
            temp = 'incentive'
            setRadioValue('weekly')
        } else if (key === 'Incentive Description') {
            temp = 'incentivedescription'
            setRadioValue('weekly')
        }
        setTab(key)
        // console.log(key)
        navigate(`/contribution/${temp}`)
    };
    useEffect(() => {
        if (tabName === 'my') {
            setTab('My Contribution')
        } else if (tabName === 'team') {
            setTab('Team Contribution')
        } else if (tabName === 'marketshare') {
            setTab('Market Share')
        } else if (tabName === 'incentive') {
            setTab('Incentive Amount')
        } else if (tabName === 'incentivedescription') {
            setTab('Incentive Description')
        }
    }, [])

    useEffect(() => {


        if (accessLevel && k === 1) {
            if (accessLevel?.access_scope?.includes('team_contribution')) {
                setTablist(prev => [...prev, 'Team Contribution'])
            }
            if (accessLevel?.access_scope?.includes('market_share')) {
                setTablist(prev => [...prev, 'Market Share'])
            }
            setTablist(prev => [...prev, 'Incentive Amount'])
            // setTablist(prev => [...prev, 'Incentive Description'])
            k = 2
        }

    }, [accessLevel])



    return (
        <div>
            <div className='header-tab' >
                <div>
                    <IoMdArrowBack style={{ cursor: 'pointer' }} onClick={() => navigate('/home')} size={30} />
                </div>
                <div>
                    <Tabs activeKey={tab}
                        onChange={onChange}
                        // type="card"
                        items={tablist?.map((data, i) => {
                            const id = String(i + 1);
                            // console.log(data)
                            return {
                                label: data,
                                key: data,
                                // children: `Content of Tab Pane ${id}`,
                            };

                        })}
                    />
                </div>
                {tab !== 'Market Share' ? <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    
                    <div>
                        <Select  value={modality} onChange={(value) => setModality(value)} mode="multiple" >
                            {modalityOption.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    {tab === 'Incentive Amount' && <div>
                        <Button 
                            // type='primary' 
                            icon={<InfoCircleOutlined />}
                            onClick={() => navigate('/incentivedescription')}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                height: '35px',
                                borderRadius: '6px',
                                fontWeight: '500',
                                marginLeft:'10px'
                            }}
                        >
                            Incentive Description
                        </Button>
                    </div>}
                    {(tab === 'Team Contribution' || (tab === 'Incentive Amount' && accessLevel?.access_scope?.includes('admin'))) &&
                    <div style={{marginLeft:'10px'}}>
                    <Select style={{width:'200px'}} showSearch value={teamName} onChange={(value) => setTeamName(value)} >
                        {[{name:'All'},...accessList].map((option) => (
                            <Select.Option key={option.name} value={option.name}>
                                {option.name}
                            </Select.Option>
                        ))}
                    </Select>

                    
                </div>    
                    }
                    {tab !== 'Incentive Amount' &&
                    <div>
                        <Radio.Group style={{ width: '200px' }} onChange={onWeeklyChange} value={radioValue}>
                            <Radio value={'weekly'}>Weekly</Radio>
                            <Radio value={'monthly'}>Monthly</Radio>
                        </Radio.Group>
                    </div>
                    

}
                </div> : <div>

                    <Radio.Group style={{ width: '200px' }} onChange={onWeeklyChange} value={radioValue}>
                        <Radio value={'state'}>By State</Radio>
                        <Radio value={'person'}>By Person</Radio>
                    </Radio.Group>
                </div>

                }
            </div>

            {
                tab == 'My Contribution' &&
                <MyContribution accessLevel={accessLevel} radioValue={radioValue} modality={modality} />

            }

            {
                (tab == 'Team Contribution' && accessLevel?.access_scope?.includes('team_contribution')) &&
                <TeamContribution accessLevel={accessLevel} teamName={teamName} radioValue={radioValue} modality={modality} />

            }

            {
                (tab == 'Market Share' && accessLevel?.access_scope?.includes('market_share')) &&
                <MarketShare accessLevel={accessLevel} radioValue={radioValue} modality={modality} />

            }

            {
                tab == 'Incentive Amount' &&
                <IncentiveAmount accessLevel={accessLevel} radioValue={radioValue} modality={modality} teamName={teamName} />

            }

            {/* {
                tab == 'Incentive Description' &&
                <IncentiveDescription />

            } */}

        </div>
    )
}

export default Main
